<div class="agu-msel">
    <button
        type="button"
        class="agu-msel__trigger"
        aria-haspopup="true"
        [attr.aria-expanded]="Open"
        [attr.aria-controls]="PanelId"
        [attr.aria-labelledby]="LabelledBy ? LabelledBy + ' ' + LabelId : null"
        (click)="Toggle()"
    >
        <span class="agu-msel__label" [id]="LabelId">{{ TriggerLabel }}</span>
        @if (Selected.length > 0) {
            <span class="agu-msel__count">{{ Selected.length }}</span>
        }
        <svg class="agu-msel__caret" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="m6 9 6 6 6-6" />
        </svg>
    </button>
    @if (Open) {
        <div class="agu-msel__panel" role="group" [id]="PanelId" [attr.aria-label]="GroupLabel">
            @for (value of Options; track value) {
                <label class="agu-msel__option">
                    <input type="checkbox" [value]="value" [checked]="IsSelected(value)" (change)="ToggleValue(value, $event)" />
                    <span>{{ value }}</span>
                </label>
            }
            <button type="button" class="agu-msel__clear agu-hit-24" [disabled]="Selected.length === 0" (click)="Clear()">Clear selection</button>
        </div>
    }
</div>
